import { ImageUp } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ImageUploadAreaProps {
  isDragging: boolean
  onClick: () => void
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void
  onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void
  onDrop: (e: React.DragEvent<HTMLDivElement>) => void
  dragText: string
  clickText: string
  orDragAndDropText: string
  formatInfo: string
}

export function ImageUploadArea({
  isDragging,
  onClick,
  onDragOver,
  onDragLeave,
  onDrop,
  dragText,
  clickText,
  orDragAndDropText,
  formatInfo,
}: ImageUploadAreaProps) {
  return (
    <div
      className={cn(
        'border-2 rounded-xl p-10 text-center cursor-pointer transition-colors flex-1 flex flex-col justify-center',
        isDragging
          ? 'border-[#A0030E] bg-red-50'
          : 'border-gray-300 hover:border-gray-400'
      )}
      onClick={onClick}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <div className='flex items-center justify-center mb-3'>
        <div className='w-10 h-10 rounded-lg border border-[#E9EAEB] flex items-center justify-center shadow-sm'>
          <ImageUp
            className={cn(
              'h-5 w-5',
              isDragging ? 'text-[#A0030E]' : 'text-gray-400'
            )}
          />
        </div>
      </div>
      <p className='text-sm'>
        {isDragging ? (
          <span className='text-[#A0030E] font-medium'>{dragText}</span>
        ) : (
          <>
            <span className='text-[#A0030E] font-medium'>{clickText}</span>{' '}
            <span className='text-gray-500'>{orDragAndDropText}</span>
          </>
        )}
      </p>
      <p className='text-xs text-gray-500 mt-1'>{formatInfo}</p>
    </div>
  )
}
